import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const clearQuotaLimits = createAction(`${moduleSlug}/CLEAR_QUOTA_LIMITS`);

export const getQuotaLimits = createAction(`${moduleSlug}/GET_QUOTA_LIMITS`);
export const getQuotaLimitsSuccess = createAction(`${moduleSlug}/GET_QUOTA_LIMITS/SUCCESS`);
export const getQuotaLimitsError = createAction(`${moduleSlug}/GET_QUOTA_LIMITS/ERROR`);

export const deleteQuotaLimits = createAction(`${moduleSlug}/DELETE_QUOTA_LIMITS`);

export const setQuotaManagerDialog = createAction(`${moduleSlug}/SET_CREDENTIAL_MANAGER_DIALOG`);
export const mergeQuotaManagerDialog = createAction(`${moduleSlug}/MERGE_CREDENTIAL_MANAGER_DIALOG`);
export const createQuotaLimits = createAction(`${moduleSlug}/CREATE_QUOTA_LIMITS`);

export const setLimitDialog = createAction(`${moduleSlug}/SET_LIMIT_DIALOG`);
export const mergeLimitDialog = createAction(`${moduleSlug}/MERGE_LIMIT_DIALOG`);
export const changeLimit = createAction(`${moduleSlug}/CHANGE_LIMIT`);
